import { render } from "./RestoreConfirmation.vue?vue&type=template&id=75a710b4"
import script from "./RestoreConfirmation.vue?vue&type=script&lang=js"
export * from "./RestoreConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__